import { createContext, useContext, useState } from "react";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [activity, setActivity] = useState(4);
  const [element, setElement]   = useState(0);

  return (
    <AppContext.Provider value={{ activity, setActivity, element, setElement }}>
      {children}
    </AppContext.Provider>
  );
}

// Custom hook for easy consumption
export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used inside <AppProvider>");
  return ctx;
}